var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47.82px",
    height: "47.82px",
    viewBox: "0 -8.14 47.82 47.82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff6368;}.cls-2{fill:#d34a5b;}.cls-3{fill:#354251;}.cls-4{fill:#c6c5c4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bread"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.36,9.49c2.09,4.82,8.08,8.2,22.55,8.2s20.48-3.35,22.55-8.13c-2.09-4.82-8.08-8.2-22.55-8.2S3.43,4.71,1.36,9.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.35,9.49c1.84-4.25,6.73-7.37,18-8-13.33-.87-24.92,1.74-27,8,2.17,6.34,13.79,9,27.07,8.08C17.17,16.93,12.22,13.78,10.35,9.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.91,19.05c-13.56,0-21.12-2.86-23.8-9A1.35,1.35,0,0,1,.11,9C2.75,2.84,10.32,0,23.91,0S45,2.87,47.71,9a1.35,1.35,0,0,1,0,1.08C45.07,16.21,37.5,19.05,23.91,19.05Zm-21-9.57c2.42,4.61,9.31,6.85,21.05,6.85,16.55,0,20-4.58,21.05-6.75-2.42-4.62-9.31-6.86-21-6.86C7.36,2.72,3.93,7.3,2.86,9.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11.64,17.69c0-.39,0-.77,0-1.15-4-.94-6.74-2.42-8.47-4.26-6,12.39,11.56,19.58,25.48,17.59C18.93,28.62,11.64,23.64,11.64,17.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33.46,17.69a55.37,55.37,0,0,0,12.23-1.13,11,11,0,0,0-1.08-4.21C42,15.11,37.18,17,28.71,17.55,30.18,17.64,31.76,17.69,33.46,17.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.91,31.53c-9.49,0-22.71-4-23.18-13.84a13.15,13.15,0,0,1,1.26-6,1.37,1.37,0,0,1,2.21-.32c3.16,3.35,9.61,5,19.71,5s16.58-1.61,19.71-4.91a1.37,1.37,0,0,1,2.21.32,13,13,0,0,1,1.26,6C46.61,27.57,33.4,31.57,23.91,31.53ZM3.79,14.62C1.08,24.84,15,28.86,23.91,28.81S46.71,24.86,44,14.68C37.48,20.52,10.34,20.53,3.79,14.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.24,16.93A1.36,1.36,0,0,1,12,15.06a16.83,16.83,0,0,0,1.13-6.24,17.08,17.08,0,0,0-1-5.77,1.36,1.36,0,0,1,2.56-.92,20.63,20.63,0,0,1-.21,14A1.35,1.35,0,0,1,13.24,16.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.58,18.24a1.37,1.37,0,0,1-1.2-2A15.55,15.55,0,0,0,23,9a16.14,16.14,0,0,0-1.4-6.77,1.36,1.36,0,0,1,2.46-1.17c2.3,4.67,2.19,11.94-.3,16.45A1.37,1.37,0,0,1,22.58,18.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.55,18.21a1.37,1.37,0,0,1-1.2-2A16.07,16.07,0,0,0,33,8.82a16.9,16.9,0,0,0-1.13-6.24,1.36,1.36,0,0,1,2.52-1c2,4.69,1.74,11.55-.65,15.91A1.36,1.36,0,0,1,32.55,18.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.85,23.33a1.51,1.51,0,0,1,0-3A1.51,1.51,0,0,1,14.85,23.33Zm0-2.72a1.22,1.22,0,0,0,0,2.43A1.22,1.22,0,0,0,14.85,20.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.8,23.33a1.51,1.51,0,0,1,0-3A1.51,1.51,0,0,1,23.8,23.33Zm0-2.72a1.22,1.22,0,0,0,0,2.43A1.22,1.22,0,0,0,23.8,20.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.76,23.33a1.51,1.51,0,0,1,0-3A1.51,1.51,0,0,1,32.76,23.33Zm0-2.72a1.22,1.22,0,0,0,0,2.43A1.22,1.22,0,0,0,32.76,20.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.57,27.66a1.51,1.51,0,0,1,0-3A1.51,1.51,0,0,1,19.57,27.66Zm0-2.73a1.22,1.22,0,0,0,0,2.43A1.22,1.22,0,0,0,19.57,24.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.52,27.66a1.51,1.51,0,0,1,0-3A1.51,1.51,0,0,1,28.52,27.66Zm0-2.73a1.22,1.22,0,0,0,0,2.43A1.22,1.22,0,0,0,28.52,24.93Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.b7b4d01687f5765e2f0ab5d4b78dff80.svg";
export { ForwardRef as ReactComponent };